(ns story-builder.translation
  (:require
   [reagent.core :as r]
   [story-builder.define :as define]
   [taoensso.tempura :as tempura]))

(def dict
  {"nl" {"tap-to-go-fwd"  "Tik en ga"
         "tap-to-go-back" "Tik en keer"
         "fwd"            "VERDER"
         "back"           "TERUG"}})

(def supported-languages [:en :es :pt :fr :de :nl :ro])

(def user-lang-ratom
  (r/atom
   (if define/frontend?
     (let [lang (keyword (.getAttribute js/document.documentElement "lang"))]
       (if (contains? (set supported-languages) lang)
         lang
         :en))
     :en)))

(def dictionary-ratom
  (r/atom
   (when define/frontend?
     (when-let [dictionary js/document.body.dataset.dictionary]
       (try
         (js->clj (js/JSON.parse (js/atob dictionary)) :keywordize-keys true)
         (catch :default _))))))

(defn change-user-lang [new-lang]
  (-> (js/fetch (str (:root define/URLs) "/studio/lang/")
                (clj->js {:method      "POST"
                          :credentials "include"
                          :headers     {"Content-Type" "application/json"}
                          :body        (js/JSON.stringify (clj->js {:language new-lang}))}))
      (.then (fn [r] (.json r)))
      (.then (fn [r] (reset! dictionary-ratom (js->clj r :keywordize-keys true)))))
  (.setAttribute js/document.documentElement "lang" (name new-lang))
  (reset! user-lang-ratom new-lang))

(def translations? (or define/env-dev? define/env-test? define/sdk?))

(defn tr [& args]
  (apply tempura/tr
         {:dict (if translations?
                  {@user-lang-ratom @dictionary-ratom}
                  {})}
         [@user-lang-ratom]
         args))
